<template>
  <div class="product-actions" :class="{ 'has-config-option': configurable }">
    <div class="product-titling">
      <h4 class="product-description">{{ description }}</h4>
    </div>
    <div class="btn-order-container" :class="{ 'no-config-option': !configurable }">
      <button
        @click="openModal"
        class="btn_order product_detail_request_info"
        :class="{ 'no-config-option': !configurable }"
        >
        Get a Quote
      </button>
      <p class="sku_hint upper">Refer to SKU when placing order: {{ entrySku }} </p>
    </div>
    <a
      v-if="configurable"
      :href="configureUrl"
      @click="storeCurrentUrl"
      class="btn_configure product_detail_configure"
    >
      Build Your Own
    </a>
    <p class="sku_hint lower">Refer to SKU when placing order: {{ entrySku }} </p>
  </div>
</template>

<script>
import EventBus from "../event_bus";

export default {
  props: [
    'form',
    'title',
    'description',
    'entryUrl',
    'entrySku',
    'canConfigure',
  ],
  computed: {
    configurable () {
      return JSON.parse(this.canConfigure);
    },
    configureUrl () {
      return `${this.entryUrl}/configure`;
    },
  },
  methods: {
    openModal: function() {
      EventBus.$emit('open-modal', null, null, 'form', [this.form, this.entrySku, this.title]);
    },
    storeCurrentUrl () {
      localStorage.setItem('configRedirectBack', window.location.href);
    },
  },
};
</script>